// extracted by mini-css-extract-plugin
export default {"annotation":"Annotation-module__annotation--YCi6_","annotationSource":"Annotation-module__annotationSource--dVVXf","annotationMessage":"Annotation-module__annotationMessage--SE4MR"};